import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getImageUrl } from "@/utils/dedaloUtils";
import Layout from "@/components/Layout/Layout";
import ResourcesLayout from "./ResourcesLayout";

export default function Photos({ section, data, close, photos, white }) {
    const { t } = useTranslation();
    const [imageOpened, setImageOpened] = useState(null);

    function previousPhoto() {
        if (imageOpened > 0) {
            setImageOpened(imageOpened - 1);
        } else {
            setImageOpened(photos.length - 1);
        }
    }

    function nextPhoto() {
        if (imageOpened < photos.length - 1) {
            setImageOpened(imageOpened + 1);
        } else {
            setImageOpened(0);
        }
    }

    return (
        <Layout section={section}>
            <ResourcesLayout data={data} close={close} white={white}>
                {imageOpened === null
                    ? (<div className="area-card--images">
                        <ul>
                            {photos.map((photo, i) => (
                                <li key={photo.section_id}>
                                    <button className="button-reset" onClick={() => setImageOpened(i)}>
                                        <img src={getImageUrl(photo.identify_image)} alt={photo.identify_image_caption} loading="lazy" width="110" height="110" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>)
                    : (<div className="area-card--images open-image flow">
                        <p>
                            <button
                                className="has-text-black has-text-weight-medium button-reset"
                                onClick={() => setImageOpened(null)}
                            >{t('Volver a la galeria')}</button>
                        </p>

                        <div className="open-image--container">
                            <img src={getImageUrl(photos[imageOpened].identify_image)} alt="" loading="lazy"/>
                        </div>

                        <div className="is-flex is-justify-content-space-between gap-3">
                            <button className="button-reset is-flex" onClick={previousPhoto}><div className="small-arrow left" aria-label={t('Ir a la fotografia anterior')}/></button>
                            <p>{photos[imageOpened].identify_image_caption}</p>
                            <button className="button-reset is-flex" onClick={nextPhoto}><div className="small-arrow right" aria-label={t('Ir a la siguiente fotografia')}/></button>
                        </div>
                    </div>)
                }
            </ResourcesLayout>
        </Layout>
    )

}